import { render, staticRenderFns } from "./TopDevices.vue?vue&type=template&id=58cb1f5e&"
import script from "./TopDevices.vue?vue&type=script&lang=js&"
export * from "./TopDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports